import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { THEME_PAGES } from "../../../data/sitePages";

const ORDER = ["yoga-retreats", "wellness-retreats", "yacht-retreats", "yoga-sailing-retreats", "retreats-for-beginners"];

export const PopularThemes = () => (
  <section data-testid="popular-themes" className="mx-auto max-w-[1400px] px-6 py-24 md:px-10 md:py-28">
    <div className="mb-10">
      <p className="overline text-brand-inkSoft">Section 03</p>
      <h2 className="mt-3 font-display text-3xl leading-tight text-brand-ink md:text-5xl">Popular retreat themes</h2>
    </div>
    <div className="divide-y divide-brand-line border-y border-brand-line">
      {ORDER.map((slug) => {
        const t = THEME_PAGES[slug];
        return (
          <Link
            key={slug}
            to={`/${slug}`}
            data-testid={`theme-link-${slug}`}
            className="group flex items-center justify-between gap-6 py-6 transition-colors hover:bg-brand-bg2/60"
          >
            <div>
              <h3 className="font-display text-2xl text-brand-ink md:text-3xl">{t.h1}</h3>
              <p className="mt-1 max-w-2xl text-sm text-brand-inkSoft">{t.description}</p>
            </div>
            <ArrowRight size={22} className="shrink-0 text-brand-terracotta transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        );
      })}
    </div>
  </section>
);

export default PopularThemes;
